import styled from 'styled-components';

export const SelectTitleDropdownContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 2.4vw;
`;

export const Expirationtitle = styled.label`
  font-family: 'Libre Franklin', sans-serif;
  font-weight: 400;
  font-size: 3.3vw;
  padding-bottom: 1.6vw;
  background-color: transparent;
  margin-left: 3.6vw;
`;

export const SelectExpirationContainer = styled.div`
  font-family: 'Libre Franklin', sans-serif;
  font-size: 2.147vh;
  font-weight: normal;
  gap: 2vw;
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
`;

export const ContainerSelect = styled.div`
  width: 20vw;
  height: 13.333vw;
  display: flex;
  align-items: center;
  position: relative;
`;

export const SelectDropdownExpiration = styled.select`
  width: 20vw;
  height: 13.333vw;
  border-radius: 1.342vh;
  border: 1px solid #cccccc;
  text-indent: 8px;
  font-size: 0.938rem;
  font-family: 'Libre Franklin', sans-serif;
  -webkit-appearance: none;
  z-index: 1;
  -moz-appearance: none;
  outline: none;
  background-color: transparent;
  color: #000000;

  &:focus {
    border: 2px solid black;
    color: black;
  }
  option {
    color: #000000;
  }
`;

export const IconArrowDown = styled.img`
  background-color: transparent;
  width: 3vw;
  height: 3vw;
  position: absolute;
  right: 2vw;
  flex: none;
`;
